module.exports = __webpack_public_path__ + "img/bg@2x.f534da9f.png";